<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Profile</h5>
                  </div>
                  <small class="text-truncate text-muted">Last profile edit: 20-Nov-2020</small>
                </div>
              </div>
            </div>
            <div class="col-7 col-xl-8 text-end">
              <button type="button" class="btn btn-info"><i class="zmdi zmdi-edit"></i> <span
                  class="hidden-md ml-1">Edit</span></button>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="card">
                <div class="card-body text-center">
                  <h5 class="mb-1">Michelle Green</h5>
                  <div class="mb-4"><i class="zmdi zmdi-check-circle text-success"></i> Online</div>
                  <img src="assets/images/user.png" alt="" class="img-fluid rounded-circle img-thumbnail shadow">
                  <div class="mt-2"><span class="badge bg-danger">Admin</span></div>

                  <div class="profile-stars mb-4 mt-2">
                    <i class="text-warning zmdi zmdi-star"></i>
                    <i class="text-warning zmdi zmdi-star ml-1"></i>
                    <i class="text-warning zmdi zmdi-star ml-1"></i>
                    <i class="text-warning zmdi zmdi-star ml-1"></i>
                    <i class="text-warning zmdi zmdi-star-o ml-1"></i>
                    <span>Super User</span>
                  </div>

                  <div class="profile-since mb-2">Member since: Jan 2016</div>
                  <ul class="list-unstyled">
                    <li class="py-1">Orders: <span class="fw-bold">245</span></li>
                    <li class="py-1">Posts: <span class="fw-bold">465</span></li>
                    <li class="py-1">Tasks done: <span class="fw-bold">1078</span></li>
                  </ul>
                  <a href="javascript:void(0)" class="btn btn-success"><i class="zmdi zmdi-envelope"></i> Send
                    message</a>
                </div>
              </div>
            </div>

            <div class="col-lg-8 col-md-8 col-sm-12">
              <div class="card mb-4">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6 col-md-12">
                      <div class="mb-3">
                        <span class="text-muted">First Name</span>
                        <h6>Michelle</h6>
                      </div>
                      <div class="mb-3">
                        <span class="text-muted">Last Name</span>
                        <h6>Green</h6>
                      </div>
                      <div class="mb-3">
                        <span class="text-muted">Address</span>
                        <h6>10880 Malibu Point, <br> Malibu, New york., 90265</h6>
                      </div>
                      <div class="mb-3">
                        <span class="text-muted">Email</span>
                        <h6>johndoe@bootdey.com</h6>
                      </div>
                      <div class="mb-0">
                        <span class="text-muted">Phone number</span>
                        <h6>+14 123 456 789</h6>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                      <ul class="list-unstyled">
                        <li class="py-2 d-flex justify-content-between align-items-center">
                          <a href="javascript:void(0)"><i class="me-2 zmdi zmdi-facebook-box"></i>@MichelleGreen</a>
                          <div>
                            <span class="badge bg-light text-dark">10k Follower</span>
                            <span class="badge bg-light text-dark mt-1">450 Friends</span>
                          </div>
                        </li>
                        <li class="py-2 d-flex justify-content-between align-items-center">
                          <a href="javascript:void(0)"><i class="me-2 zmdi zmdi-github-box"></i>MichelleGreen</a>
                          <div>
                            <span class="badge bg-danger">23 Repositories</span>
                            <span class="badge bg-light text-dark mt-1">18 Projects</span>
                          </div>
                        </li>
                        <li class="py-2 d-flex justify-content-between align-items-center">
                          <a href="javascript:void(0)"><i class="me-2 zmdi zmdi-instagram"></i>MichelleGreen</a>
                          <div>
                            <span class="badge bg-light text-dark">10k Follower</span>
                          </div>
                        </li>
                        <li class="py-2 d-flex justify-content-between align-items-center">
                          <a href="javascript:void(0)"><i class="me-2 zmdi zmdi-linkedin-box"></i>Black_widow</a>
                          <div>
                            <span class="badge bg-light text-dark">450 Connection</span>
                          </div>
                        </li>
                        <li class="py-2 d-flex justify-content-between align-items-center">
                          <a href="javascript:void(0)"><i class="me-2 zmdi zmdi-twitter-box"></i>@M_Green</a>
                          <div>
                            <span class="badge bg-light text-dark">5k Follower</span>
                            <span class="badge bg-light text-dark ml-1">219 Twitt</span>
                          </div>
                        </li>
                        <li class="py-2 d-flex justify-content-between align-items-center">
                          <a href="javascript:void(0)"><i class="me-2 zmdi zmdi-skype"></i>Michelle_Green</a>
                        </li>
                      </ul>
                    </div>
                  </div> <!-- .row end -->
                </div>
                <!-- tab: nav -->
                <div class="card-footer p-0">
                  <ul class="nav nav-tabs page-header-tabs border-bottom-0 px-3">
                    <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('1')"
                        [ngClass]="{'active': activityTab}">Activity</a></li>
                    <li class="nav-item"><a href="javascript:void(0)" (click)="onMenuTab('2')"
                        [ngClass]="{'active': friendsTab}" class="nav-link">Friends</a></li>
                    <li class="nav-item"><a href="javascript:void(0)" (click)="onMenuTab('3')"
                        [ngClass]="{'active': galleryTab}" class="nav-link">Gallery</a></li>
                  </ul>
                </div>
              </div>

              <!-- tab: content -->
              <div class="tab-content mb-4">
                <div class="tab-pane fade show active" id="user-activity" [ngClass]="{'show active': activityTab}">
                  <div class="card">
                    <div class="card-body">
                      <ol class="activity-feed p-0 ms-3 mb-0 pt-4">
                        <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="3 hours ago"
                          data-color="green">
                          <div class="card mb-5">
                            <div class="card-body">
                              <input type="checkbox" id="expand_1" name="expand_1">
                              <label for="expand_1" class="mb-0">
                                <b>Etiam feugiat</b> dolor nec molestie <b>posuere.</b>
                              </label>
                              <div class="feed-content">
                                <div class="px-4">
                                  <blockquote>Duis iaculis commodo condimentum. Donec quis felis libero. Nunc feugiat
                                    nisi
                                    ut ullamcorper congue. Ut tempus egestas mauris et scelerisque. Sed tincidunt ante
                                    ligula, eget pharetra mi pretium eget. Fusce tincidunt, elit blandit semper
                                    sollicitudin, sapien lectus lobortis quam, ac bibendum lectus risus quis lectus.
                                  </blockquote>
                                  <blockquote>Duis iaculis commodo condimentum. Donec quis felis libero. Nunc feugiat
                                    nisi
                                    ut ullamcorper congue. Ut tempus egestas mauris et scelerisque. Sed tincidunt ante
                                    ligula, eget pharetra mi pretium eget. Fusce tincidunt, elit blandit semper
                                    sollicitudin, sapien lectus lobortis quam, ac bibendum lectus risus quis lectus.
                                  </blockquote>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="3 hours ago"
                          data-color="blue">
                          <div class="card mb-5">
                            <div class="card-body">
                              <input type="checkbox" id="expand_2" name="expand_2">
                              <label for="expand_2" class="mb-0">
                                <b>Aliquam</b> non diam <b>consectetur.</b>
                              </label>
                              <div class="feed-content">
                                <article class="media mb-0">
                                  <div class="me-3">
                                    <img class="rounded" src="assets/images/xs/avatar4.jpg" alt="">
                                  </div>
                                  <div class="media-body">
                                    <div class="content">
                                      <p class="h6">John Smith <small>@johnsmith</small></p>
                                      <p>Duis iaculis commodo condimentum. Donec quis felis libero. Nunc feugiat nisi ut
                                        ullamcorper congue.</p>
                                    </div>
                                    <nav class="d-flex text-muted font-13">
                                      <a href="javascript:void(0)" class="icon me-3"><i
                                          class="me-1 zmdi zmdi-replay"></i></a>
                                      <a href="javascript:void(0)" class="icon me-3"><i
                                          class="me-1 zmdi zmdi-twitter"></i>24</a>
                                      <a href="javascript:void(0)" class="icon me-3"><i
                                          class="me-1 zmdi zmdi-favorite"></i>43</a>
                                      <a href="javascript:void(0)" class="text-muted ms-auto">5 notes</a>
                                    </nav>
                                  </div>
                                </article>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="4 hours ago"
                          data-color="red">
                          <div class="card mb-5">
                            <div class="card-body">
                              <input type="checkbox" id="expand_3" name="expand_3">
                              <label for="expand_3" class="mb-0">
                                <b>Nullam</b> mollis massa ut <b>egestas viverra.</b>
                              </label>
                              <div class="feed-content">
                                <img src="assets/images/gallery/1.jpg" alt="">
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="6 hours ago"
                          data-color="green">
                          <div class="card mb-5">
                            <div class="card-body">
                              <label for="expand_4" class="mb-0">
                                <b>Etiam feugiat</b> dolor nec molestie <b>posuere.</b>
                                <br>
                                Donec quis felis libero.
                                <b>Etiam feugiat</b> dolor nec molestie <b>posuere.</b>
                                <br>
                                Donec quis felis libero.
                                <b>Etiam feugiat</b> dolor nec molestie <b>posuere.</b>
                                <br>
                                Donec quis felis libero.
                              </label>
                            </div>
                          </div>
                        </li>
                        <li class="feed-item mb-3 pl-lg-4 ps-3" data-content="" data-time="7 hours ago"
                          data-color="yellow">
                          <div class="card mb-0">
                            <div class="card-body">
                              <input type="checkbox" id="expand_5" name="expand_5">
                              <label for="expand_5" class="mb-0">
                                <b>Pellentesque accumsan</b> ligula a tincidunt <b>venenatis.</b>
                              </label>
                              <div class="feed-content">
                                <h2>BOOM!</h2>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="user-friends" [ngClass]="{'show active': friendsTab}">
                  <div class="card mb-1">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <!-- Avatar -->
                        <div class="col-auto">
                          <a href="javascript:void(0)" class="avatar"><img src="assets/images/xs/avatar1.jpg" alt="..."
                              class="rounded-circle"></a>
                        </div>

                        <div class="col ml-n2">
                          <!-- Title -->
                          <h5 class="mb-1"><a href="javascript:void(0)">Michelle Green</a></h5>
                          <!-- Text -->
                          <p class="small text-muted mb-1">You either die Spongebob or you live long enough to...</p>
                          <!-- Status -->
                          <p class="small mb-0"><span class="text-success">●</span> Online</p>
                        </div>

                        <!-- Button -->
                        <div class="col-auto">
                          <a href="javascript:void(0)!"
                            class="btn btn-sm btn-light d-none d-md-inline-block">Following</a>
                          <a href="javascript:void(0)!"
                            class="btn btn-sm btn-danger d-none d-md-inline-block ml-1">Unfriend</a>
                        </div>

                        <!-- Dropdown -->
                        <div class="col-auto">
                          <div class="dropdown" dropdown placement="bottom right">
                            <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                              class="btn btn-link btn-sm dropdown-toggle">
                              <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                            </button>
                            <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                              aria-labelledby="button-basic">
                              <a href="javascript:void(0);" class="dropdown-item">Action</a>
                              <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                              <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                            </div>
                          </div>

                        </div>

                      </div> <!-- / .row -->
                    </div> <!-- / .card-body -->
                  </div>
                  <div class="card mb-1">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <!-- Avatar -->
                        <div class="col-auto">
                          <a href="javascript:void(0)" class="avatar"><img src="assets/images/xs/avatar2.jpg" alt="..."
                              class="rounded-circle"></a>
                        </div>

                        <div class="col ml-n2">
                          <!-- Title -->
                          <h5 class="mb-1"><a href="javascript:void(0)">Barbara Kelly</a></h5>
                          <!-- Text -->
                          <p class="small text-muted mb-1">You either die Spongebob or you live long enough to...</p>
                          <!-- Status -->
                          <p class="small mb-0"><span class="text-success">●</span> Online</p>
                        </div>

                        <!-- Button -->
                        <div class="col-auto">
                          <a href="javascript:void(0)!"
                            class="btn btn-sm btn-light d-none d-md-inline-block">Following</a>
                          <a href="javascript:void(0)!"
                            class="btn btn-sm btn-danger d-none d-md-inline-block ml-1">Unfriend</a>
                        </div>

                        <!-- Dropdown -->
                        <div class="col-auto">
                          <div class="dropdown" dropdown placement="bottom right">
                            <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                              class="btn btn-link btn-sm dropdown-toggle">
                              <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                            </button>
                            <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                              aria-labelledby="button-basic">
                              <a href="javascript:void(0);" class="dropdown-item">Action</a>
                              <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                              <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                            </div>
                          </div>
                        </div>

                      </div> <!-- / .row -->
                    </div> <!-- / .card-body -->
                  </div>
                  <div class="card mb-1">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <!-- Avatar -->
                        <div class="col-auto">
                          <a href="javascript:void(0)" class="avatar"><img src="assets/images/xs/avatar3.jpg" alt="..."
                              class="rounded-circle"></a>
                        </div>

                        <div class="col ml-n2">
                          <!-- Title -->
                          <h5 class="mb-1"><a href="javascript:void(0)">Brian Swader</a></h5>
                          <!-- Text -->
                          <p class="small text-muted mb-1">You either die Spongebob or you live long enough to...</p>
                          <!-- Status -->
                          <p class="small mb-0"><span class="text-success">●</span> Online</p>
                        </div>

                        <!-- Button -->
                        <div class="col-auto">
                          <a href="javascript:void(0)!"
                            class="btn btn-sm btn-light d-none d-md-inline-block">Following</a>
                          <a href="javascript:void(0)!"
                            class="btn btn-sm btn-danger d-none d-md-inline-block ml-1">Unfriend</a>
                        </div>

                        <!-- Dropdown -->
                        <div class="col-auto">
                          <div class="dropdown" dropdown placement="bottom right">
                            <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                              class="btn btn-link btn-sm dropdown-toggle">
                              <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                            </button>
                            <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                              aria-labelledby="button-basic">
                              <a href="javascript:void(0);" class="dropdown-item">Action</a>
                              <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                              <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                            </div>
                          </div>
                        </div>

                      </div> <!-- / .row -->
                    </div> <!-- / .card-body -->
                  </div>
                </div>
                <div class="tab-pane fade" id="user-gallery" [ngClass]="{'show active': galleryTab}">
                  <div class="card">
                    <div class="card-body">
                      <h6>No data to show!</h6>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div> <!-- .row end -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
